<template>
  <v-card-actions class="d-flex transparent ml-auto mr-auto mt-4 pa-0 actions-container"
                  :style="{'padding-right': scrollBar+'px !important'}">
    <v-btn class="theme-background theme-border ma-0 mr-4 timelineItemText" min-height="44px" tile depressed
           @click="selectAll" :disabled="!hasSelectAble">
      <v-icon class="mr-2">mdi-checkbox-multiple-marked</v-icon>
      Összes kijelölése
    </v-btn>

    <v-btn class="theme-background theme-border ma-0 ml-4 mr-4 timelineItemText theme-green" min-height="44px" tile
           depressed @click="approveAll" :disabled="!hasSelected">
      <v-icon class="mr-2">mdi-check-all</v-icon>
      Kijelöltek elfogadása
    </v-btn>

    <v-btn class="theme-background theme-border ma-0 ml-4 timelineItemText theme-red" min-height="44px" tile depressed
           @click="missingAction" :disabled="isPassive">
      <v-icon class="mr-2">mdi-alert-circle-outline</v-icon>
      Hiányzó esemény
    </v-btn>

    <v-btn class="theme-background theme-border ma-0 ml-4 timelineItemText theme-green" min-height="44px" tile depressed
           @click="summaryDialog = true">
      <v-icon class="mr-2">mdi-chart-bar</v-icon>
      Összesítés
    </v-btn>

    <v-dialog v-model="summaryDialog"  max-width="1440"
              scrollable
              persistent>
      <v-card>
        <v-card-title class="text-h6">
          Összesítés
        </v-card-title>

        <v-card-text>
          <v-row>
            <v-col>
              <v-data-table
                  :headers="headers"
                  :items="itemsA"
                  class="elevation-1"
                  dense
                  hide-default-footer
                  :disable-pagination="true"
                  :items-per-page="50"
                  fixed-header
                  height="400"
                  :item-class="getRowClass"
              >
                <template v-slot:item="{ item }">
                  <tr :class="item.jersey === 199 ? 'summary-row' : ''">
                    <td>
                      <span v-if="item.jersey !== 199">{{ item.jersey }}</span>
                    </td>
                    <td>{{ item.name }}</td>
                    <td><strong v-if="item.gol > 0">{{ item.gol }}</strong></td>
                    <td><strong v-if="item.sargalap > 0" style="color: #FFD600">{{ item.sargalap }}</strong></td>
                    <td><strong v-if="item.ketperc > 0" style="color: #D50000">{{ item.ketperc }}</strong></td>
                    <td><strong v-if="item.piroslap > 0" style="color: #D50000">{{ item.piroslap }}</strong></td>
                    <td><strong v-if="item.keklap > 0" style="color: #304FFE">{{ item.keklap }}</strong></td>
                  </tr>
                </template>
              </v-data-table>
            </v-col>
            <v-col>
              <v-data-table
                  :headers="headers"
                  :items="itemsB"
                  class="elevation-1"
                  dense
                  fixed-header
                  :disable-pagination="true"
                  hide-default-footer
                  :items-per-page="50"
                  height="400"
                  :item-class="getRowClass"
              >
                <template v-slot:item="{ item }">
                  <tr :class="item.jersey === 199 ? 'summary-row' : ''">
                    <td>
                      <span v-if="item.jersey !== 199">{{ item.jersey }}</span>
                    </td>
                    <td>{{ item.name }}</td>
                    <td><strong v-if="item.gol > 0">{{ item.gol }}</strong></td>
                    <td><strong v-if="item.sargalap > 0" style="color: #FFD600">{{ item.sargalap }}</strong></td>
                    <td><strong v-if="item.ketperc > 0" style="color: #D50000">{{ item.ketperc }}</strong></td>
                    <td><strong v-if="item.piroslap > 0" style="color: #D50000">{{ item.piroslap }}</strong></td>
                    <td><strong v-if="item.keklap > 0" style="color: #304FFE">{{ item.keklap }}</strong></td>
                  </tr>
                </template>
              </v-data-table>
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="summaryDialog = false">Bezárás</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card-actions>
</template>

<script>
import eventBus from '@/eventBus';
import CONSTANTS from "@/constants";

export default {
  name: 'ActionsContainer',
  data() {
    return {
      summaryDialog: false,
      headers: [
        { text: 'Mez', value: 'jersey' },
        { text: 'Játékos', value: 'name' },
        { text: 'Gólok', value: 'gol' },
        { text: 'Sárga lap', value: 'sargalap' },
        { text: '2 perc', value: 'ketperc' },
        { text: 'Piros lap', value: 'piroslap' },
        { text: 'Kék lap', value: 'keklap' },
      ]
    }
  },
  props: {
    timelineItems: Array,
    fullTimelineItems: Array,
    dmrPlayers: Array,
    scrollBar: Number,
    isPassive: Boolean
  },
  methods: {
    getRowClass(item) {
      return item.jersey === 199 ? 'summary-row' : null;
    },
    sortByJersey(players) {
      const prioritySuffix = ['A', 'B', 'C', 'D', 'E'];

      return players.slice().sort((a, b) => {
        const aVal = String(a.jersey);
        const bVal = String(b.jersey);

        const aIsSpecial = prioritySuffix.includes(aVal);
        const bIsSpecial = prioritySuffix.includes(bVal);

        if (aIsSpecial && !bIsSpecial) return 1;
        if (!aIsSpecial && bIsSpecial) return -1;

        if (aIsSpecial && bIsSpecial) {
          return prioritySuffix.indexOf(aVal) - prioritySuffix.indexOf(bVal);
        }

        // Ha mindkettő szám, akkor növekvő szerint
        return Number(aVal) - Number(bVal);
      });
    },
    selectAll: function () {
      eventBus.$emit(CONSTANTS.DMR.SELECT_ALL);
    },
    approveAll: function () {
      eventBus.$emit(CONSTANTS.DMR.APPROVE_ALL);
    },
    missingAction: function () {
      eventBus.$emit(CONSTANTS.DMR.MISSING_MODAL);
    },
    getFilteredData(team)
    {
      let sorted = this.dmrPlayers.filter(t => t.team === team && t.jersey);


      for (const it in sorted) {
        sorted[it]["gol"] = 0;
        sorted[it]["sargalap"] = 0;
        sorted[it]["ketperc"] = 0;
        sorted[it]["piroslap"] = 0;
        sorted[it]["keklap"] = 0;
      }

      const filtered = this.fullTimelineItems.filter(t =>t.team === team);

        for (const it2 in filtered) {
          switch(filtered[it2].action)
          {
            case 'gol':
            case 'gol7m':
              for (const it in sorted) {
                if (sorted[it].id === filtered[it2].player.id) {
                  sorted[it]['gol'] += 1;
                }
              }
              break;
            case '2perc':
              for (const it in sorted) {
                if (sorted[it].id === filtered[it2].player.id) {
                  sorted[it]['ketperc'] += 1;
                }
              }
              break;
            case '4perc':
              for (const it in sorted) {
                if (sorted[it].id === filtered[it2].player.id) {
                  sorted[it]['ketperc'] += 2;
                }
              }
              break;
            case 'piroslap':
            case 'keklap':
            case 'sargalap':
              for (const it in sorted) {
                if (sorted[it].id === filtered[it2].player.id) {
                  sorted[it][filtered[it2].action] += 1;
                }
              }
              break;
          }
        }

      const totalRow = {
      id: 'osszesen',
      name: 'ÖSSZESEN',
      jersey: 199,
      team: team,
      gol: 0,
      sargalap: 0,
      ketperc: 0,
      piroslap: 0,
      keklap: 0
    };

// Összegzés a játékosok alapján
      for (const player of sorted.filter(t => !isNaN(t.jersey))) {
        totalRow.gol += player.gol;
        totalRow.sargalap += player.sargalap;
        totalRow.ketperc += player.ketperc;
        totalRow.piroslap += player.piroslap;
        totalRow.keklap += player.keklap;
      }

// Hozzáfűzzük a végére
      sorted.push(totalRow);

      sorted = this.sortByJersey(sorted);

      return sorted;
    }
  },
  computed: {
    itemsA: function () {
      return this.getFilteredData('A');
    },
    itemsB: function () {
      return this.getFilteredData('B');
    },
    hasSelectAble: function () {
      let self = this;

      let nonSelectedItems = self.timelineItems.filter(function (item) {
        return !item.checked && !item.approved && !item.rejectReason && !item.draft && item.action !== 'periodchange';
      });

      return nonSelectedItems.length;
    },
    hasSelected: function () {
      let self = this;

      let selectedItems = self.timelineItems.filter(function (item) {
        return item.checked;
      });

      return selectedItems.length;
    }
  }
}
</script>

<style scoped>
.timelineItemText {
  font-size: 12px;
  font-stretch: condensed;
  width: 220px;
}

.summary-row {
  font-weight: bold;
  background-color: #40434f; /* opcionális világos háttér kiemeléshez */
}
</style>
